import { TabContentTranslations } from ".";

export const TAB_CONTENT_ES_MX: TabContentTranslations = {
	consolidated: "Consolidados",
	extract: "Extracto",
};
